export default __webpack_public_path__ + "static/media/nvsirpropic.bda7c961.png";